export default {
  towns: [],
  town: {},
  companies: [],
  simplifiedCompanies: [],
  companyArticles: [],
  commercialists: [],
  masterCompanies: [],
  mergeOrdersResponse: {},
  commercialistsForCompanies: [],
  shippingTowns: [],
  pager: {
    currentPage: 1,
    totalItems: 0,
    totalPages: 1,
  },
  parentCompanies: [],
  subCompaniesByParent: [],
  company: {},
  superBonus: {},
  superBonuses: [],
  users: [],
  selectedUser: {},
  userShippingInfo: {},
  token: localStorage.getItem('token') || null,
  profile: localStorage.getItem('profile') ? JSON.parse(localStorage.getItem('profile')) : {},
  userProfile: { userData: {}, shippingInfoData: {} },
  countries: [],
  country: {},
  categories: [],
  parentCategories: [],
  childCategories: [],
  simplifiedCategories: [],
  category: {},
  categoryArticles: [],
  categoryPriorityArticles: [],
  articles: [],
  searchVariations: [],
  presentationRequests: [],
  article: {},
  articleCopy: null,
  blogCopy: null,
  newsletters: [],
  banks: [],
  bank: {},
  brand: {},
  currencies: [],
  currency: {},
  measurementUnits: [],
  measurementUnit: {},
  brands: [],
  taxes: [],
  expressPosts: [],
  expressPost: {},
  tabs: [],
  tab: {},
  productSales: [],
  productSale: {},
  interestsAreas: [],
  interestsArea: {},
  customerBankAccounts: [],
  customerBankAccount: {},
  blogs: [],
  blog: {},
  terms: [],
  attributes: [],
  attribute: {},
  attributeValues: [],
  articleVariations: [],
  systemMessages: [],
  highlightedBrands: [],
  highlightedBrand: {},
  jumbotrons: [],
  jumbotron: {},
  highlightedCategories: [],
  highlightedCategory: {},
  banners: [],
  banner: {},
  newlyAddedArticles: [],
  articleTags: [],
  tags: [],
  tag: {},
  shoppingCarts: [],
  shoppingCart: {},
  wishLists: [],
  wishList: {},
  orders: [],
  order: {},
  orderStates: [],

  // Roles
  roles: [],
  simplifiedRoles: [],
  role: {},

  // Permissions
  permissions: [],

  // Service managers
  serviceManagers: [],
  serviceManager: {},

  // Customer files
  customerFiles: [],
  customerFile: {},
  
  // Complaints
  complaints: [],
  complaint: {},

  // Article
  articleFilters: {
    categories: [],
    brands: [],
  },

  // Media library
  mediaLibrary: [],

  // Meta SEO
  metaSeo: {},

  // Reviews
  reviews: [],
  review: {},

  // Promo codes
  promoCodes: [],
  promoCode: {},

  // Gift cards
  giftCards: [],
  giftCard: {},

  // Top brand list
  topBrandList: [],
  topBrandListSingle: {},

  // Offers
  offers: [],
  offer: {},

  // Personal data change requests
  personalDataChangeRequests: [],
  personalDataChangeRequest: {},

  // Settings
  settings: {},
  showOffers: false,
  showAdvancedOffers: false,

  // B2C Settings
  b2cSettings: {},

  // Cleaning areas
  cleaningAreas: [],
  parentCleaningAreas: [],
  cleaningArea: {},

  // Cleaning plan note icons
  cleaningPlanNoteIcons: [],
  cleaningPlanNoteIcon: {},

  // Cleaning plans
  cleaningPlans: [],
  cleaningPlan: {},

  // Price policies
  pricePolicies: [],
  pricePolicy: {},
  defaultPricePolicyTypes: [],
  pricePolicyItems: [],

  // Dashboard
  dashboardData: {
    revenue: {},
    customersByLocation: {},
    recentOrders: {},
    topSellingArticles: [],
  },

  // Out of stock articles
  outOfStockArticles: [],
  outOfStockArticle: {},

  // Customer requests
  customerRequests: [],

  // Allowed document extensions
  allowedDocumentExtensions: [],

  // Logged user permissions
  loggedUserPermissions: localStorage.getItem('user.permissions') ? JSON.parse(localStorage.getItem('user.permissions')) : [],
};
